import { DeclarationCountry } from 'store/declarations/enums/common/declaration-country';

export const getDeclarationCountryLabel = (country: DeclarationCountry) => {
    return country === DeclarationCountry.IRELAND ? 'Ireland' : 'UK';
};
